<div id="background-animation">
  <div class="rect" />
</div>

<style>
  #background-animation {
    width: 100%;
    height: 100vh;
    position: absolute;

    z-index: 1;
  }
  .rect {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 100px;
    border: 4px solid white;
    border-radius: 15%;
    opacity: 0.3;
  }
</style>
